import { render, staticRenderFns } from "./pickup_address.vue?vue&type=template&id=5fe23305&"
import script from "./pickup_address.vue?vue&type=script&lang=js&"
export * from "./pickup_address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports